import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { makeSetStoreField } from '@hh.ru/redux-create-reducer/lib/createReducer';

import { useSelector } from 'src/hooks/useSelector';
import { setSearchDraftClustersOrder } from 'src/models/search/common/clustersOrder/draft';
import { setSearchDraftCount } from 'src/models/search/common/draft';

const criteriaCurrencyCodeDraftAction = makeSetStoreField('criteriaCurrencyCodeDraft');
const searchDraftClustersAction = makeSetStoreField('searchDraftClusters');
const novaSortsDraftAction = makeSetStoreField('novaSortsDraft');

export const useInitDraftClusters = () => {
    const counts = useSelector((state) => state.searchCounts.value);
    const novaSorts = useSelector((state) => state.novaSorts);
    const clusters = useSelector((state) => state.searchClusters);
    const order = useSelector((state) => state.searchClustersOrder);
    const criteriaCurrencyCode = useSelector((state) => state.criteriaCurrencyCode);

    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch([
            criteriaCurrencyCodeDraftAction(criteriaCurrencyCode),
            novaSortsDraftAction(novaSorts),
            setSearchDraftCount(counts),
            searchDraftClustersAction(clusters),
            setSearchDraftClustersOrder(order),
        ]);
    }, [dispatch, clusters, counts, criteriaCurrencyCode, novaSorts, order]);
};
